import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getAreaList } from '@/api/modules/system-management/area-management';

export const getCustomerManagerUserList = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/getCustomerManagerUserList',
        data: data,
        method: 'post'
    });
};

export const getCustomerManagerUserDetail = userCustomerManagerLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/getCustomerManagerUserDetail',
        data: { userCustomerManagerLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserCustomerManagerEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch)
    ]).then(axiosRequest.spread(function (area) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data
                }
            };
        }
    }));
};

export const customerManagerUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/customerManagerUserSave',
        data: data,
        method: 'post'
    });
};

export const customerManagerUserYsDeptSave = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/customerManagerUserYsDeptSave',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmAcceptCusMgrList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmAcceptCusMgrList',
        data: data,
        method: 'post'
    });
};

export const addSeedFarmAcceptCusMgr = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/addSeedFarmAcceptCusMgr',
        data: data,
        method: 'post'
    });
};

export const updateSeedFarmAcceptCusMgr = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/updateSeedFarmAcceptCusMgr',
        data: data,
        method: 'post'
    });
};

export const getUserCustomerManagerList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getUserCustomerManagerList',
        data: data,
        method: 'post'
    });
};

export const generateSeedFarmAcceptCusMgr = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/generateSeedFarmAcceptCusMgr',
        data: data,
        method: 'post'
    });
};

export const getManagerRegionList = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/getManagerRegionList',
        data: data,
        method: 'post'
    });
};

export const addManagerRegion = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/addManagerRegion',
        data: data,
        method: 'post'
    });
};

export const deleteManagerRegion = data => {
    return axios.request({
        url: 'api/accountManagement/customerManagerUserManagement/deleteManagerRegion',
        data: data,
        method: 'post'
    });
};
